import { Type } from '@angular/core';
import { PickUpBaseStep, ValidateBookingActionBaseComponent } from '@luggagehero/features/bookings';

import {
  LeaveFeedbackActionComponent,
  PickUpActionComponent,
  ShowPickupConfirmationActionComponent,
  ShowReceiptActionComponent,
  ValidateBookingActionComponent,
} from '../booking-actions';

export class PickUpStep extends PickUpBaseStep {
  protected get pickUpActionComponentType(): Type<PickUpActionComponent> {
    return PickUpActionComponent;
  }

  protected get showPickupConfirmationActionComponentType(): Type<ShowPickupConfirmationActionComponent> {
    return ShowPickupConfirmationActionComponent;
  }

  protected get showReceiptActionComponentType(): Type<ShowReceiptActionComponent> {
    return ShowReceiptActionComponent;
  }

  protected get leaveFeedbackActionComponentType(): Type<LeaveFeedbackActionComponent> {
    return LeaveFeedbackActionComponent;
  }

  protected get validateBookingActionComponentType(): Type<ValidateBookingActionBaseComponent> {
    return ValidateBookingActionComponent;
  }
}
